import { REFUND_LOG_COLUMN, REFUND_LOG_SORTING_COLUMN } from '../../constants/refundLogRow';
import { RefundLogColumnTitle } from './RefundLogColumnTitle';

export const RefundLogColumnTitles: React.FC<any> = (): JSX.Element => {
  return (
    <div className="d-flex flex-row pb-4 refund-log-headers">
      <RefundLogColumnTitle
        title={REFUND_LOG_COLUMN.DATE}
        name={REFUND_LOG_SORTING_COLUMN.TRANSACTION_AT}
        tooltipMessage="refund_journal_date_time_col_hdr_infotip"
      />
      <RefundLogColumnTitle
        title={REFUND_LOG_COLUMN.AUTHOR}
        name={REFUND_LOG_SORTING_COLUMN.AUTHOR_NAME}
        tooltipMessage="refund_journal_refund_issuer_col_hdr_infotip"
      />
      <RefundLogColumnTitle
        title={REFUND_LOG_COLUMN.BRANCH}
        name={REFUND_LOG_SORTING_COLUMN.BRANCH_NAME}
        tooltipMessage="refund_journal_branch_col_hdr_infotip"
      />
      <RefundLogColumnTitle
        title={REFUND_LOG_COLUMN.ORDER_ID}
        name={REFUND_LOG_SORTING_COLUMN.ORDER_REFERENCE}
        tooltipMessage="refund_journal_order_id_col_hdr_infotip"
      />
      <RefundLogColumnTitle
        title={REFUND_LOG_COLUMN.AMOUNT}
        name={REFUND_LOG_SORTING_COLUMN.TRANSACTION_AMOUNT}
        tooltipMessage="refund_journal_amount_and_valuta_col_hdr_infotip"
      />
      <RefundLogColumnTitle
        title={REFUND_LOG_COLUMN.STATUS}
        name={REFUND_LOG_SORTING_COLUMN.TRANSACTION_STATUS}
        tooltipMessage="refund_journal_refund_status_col_hdr_infotip"
      />
      <RefundLogColumnTitle
        title={REFUND_LOG_COLUMN.TYPE}
        name={REFUND_LOG_SORTING_COLUMN.TRANSACTION_TYPE}
        tooltipMessage="refund_journal_refund_type_col_hdr_infotip"
      />
      <RefundLogColumnTitle
        title={REFUND_LOG_COLUMN.REASON}
        name={REFUND_LOG_SORTING_COLUMN.TRANSACTION_REASON}
        tooltipMessage="refund_journal_refund_reason_col_hdr_infotip"
      />
      <RefundLogColumnTitle
        title={REFUND_LOG_COLUMN.ARN}
        name={REFUND_LOG_SORTING_COLUMN.TRANSACTION_ARN}
        tooltipMessage="refund_journal_refund_transaction_arn_col_hdr_infotip"
      />
    </div>
  );
};
